import React from 'react';
import './sass/App.scss';
import { Provider } from 'react-redux';
import store from '../src/store';
import WallPreview from './modules/WallPreview/WallPreview';
import ARViewer from './modules/WallPreview/ARViewer';
import { MuiThemeProvider } from '@material-ui/core/styles';
import muiTheme from './muiTheme';
import queryString from 'query-string';

const theme = muiTheme;
const params = queryString.parse(window.location.search);
const isARMode = params.mode === 'ar';

function App() {
    return (
        <MuiThemeProvider theme={theme}>
            <Provider store={store}>
                {isARMode ? <ARViewer /> : <WallPreview />}
            </Provider>
        </MuiThemeProvider>
    );
}

export default App;
